(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('Task', Task);

    Task.$inject = ['$resource', 'DateUtils'];

    function Task ($resource, DateUtils) {
        var resourceUrl =  'api/observations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.registerDate = DateUtils.convertLocalDateFromServer(data.registerDate);
                        if (data.reminderDate){
                            data.reminderDate = DateUtils.convertLocalDateFromServer(data.reminderDate);
                        }
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.registerDate = DateUtils.convertLocalDateToServer(copy.registerDate);
                    if (copy.reminderDate){
                        copy.reminderDate = DateUtils.convertLocalDateToServer(copy.reminderDate);
                    }
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.registerDate = DateUtils.convertLocalDateToServer(copy.registerDate);
                    if (copy.reminderDate){
                        copy.reminderDate = DateUtils.convertLocalDateToServer(copy.reminderDate);
                    }
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
